import { ExperienceStatus, Membership, Product, ProductObject, Seller, UnitType } from "types";

export const getDefaultMembership = (seller: Seller): Omit<Membership, "id"> => {
    return {
        name: "",
        desc: "",
        refundPolicy: "",
        price: 0,
        seller: { id: seller.id },
        currency: seller.currency,
        object: ProductObject.MEMBERSHIP,
    };
};

export const isDraft = (membership: Membership) => {
    return membership.status === ExperienceStatus.DRAFT;
};

/** TODO: Update the following function to return benefits or restrictions not configured reason based on membership data */
export const getDraftReasons = (membership: Membership) => {
    const draftReasons: string[] = [];

    if (isDraft(membership)) {
        draftReasons.push("Benefits not configured");
    }

    return draftReasons;
};

export const getMembershipCatalog = (product: Product) => {
    const demographics = product.catalog?.items?.filter((catalogItem) => {
        return catalogItem.unitType === UnitType.MEMBERSHIP;
    });

    return demographics ?? [];
};
